export interface Testimonial {
  quote: string
  highlight: string
  name: string
  role: string
  avatar: string
  metric: string
  metricLabel: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Pasé de terminar los 21k destruido a completar mis primeros 42k de montaña sintiéndome entero. La clave fue el plan de fuerza que nunca antes me habían explicado.',
    highlight: 'sintiéndome entero',
    name: 'Carlos M.',
    role: 'Corredor de Trail',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/1ff5b5c7-5c75-4cf7-a22b-09ebf0dfc4ad.jpg',
    metric: '42k',
    metricLabel: 'primer maratón de montaña',
  },
  {
    quote:
      'Bajé 15 minutos mi marca en la misma carrera del año pasado. Los protocolos de descenso me dieron la confianza que me faltaba.',
    highlight: '15 minutos',
    name: 'Lucía G.',
    role: 'Amateur',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/a3277414-9f26-43a5-bfda-c8cddfe5f15e.jpg',
    metric: '−15 min',
    metricLabel: 'misma carrera, un año después',
  },
]
